import axios, { AxiosError } from 'axios'
import { useMutation, useQuery } from 'react-query'

import {
  BirthdayShareCreated,
  BirthdayShareSelection,
  BirthdayShareSnapshot,
} from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const loadBirthdayShare = async (
  id: string
): Promise<BirthdayShareSnapshot> => {
  const response = await axios.get<BirthdayShareSnapshot>(
    `${getEndpoint()}/birthday/shares/${encodeURIComponent(id)}`
  )
  return response.data
}

const saveBirthdayShare = async (
  selection: BirthdayShareSelection
): Promise<BirthdayShareCreated> => {
  const response = await axios.post<BirthdayShareCreated>(
    `${getEndpoint()}/birthday/shares`,
    selection
  )
  return response.data
}

export const useBirthdayShare = (id: string | null) =>
  useQuery<BirthdayShareSnapshot, AxiosError>(
    ['birthday', 'share', id],
    () => loadBirthdayShare(id as string),
    {
      enabled: Boolean(id),
      retry: false,
    }
  )

export const useSaveBirthdayShare = () =>
  useMutation<BirthdayShareCreated, AxiosError, BirthdayShareSelection>(
    saveBirthdayShare
  )
